import type {Directive} from 'vue';
import {useDisplayMobile} from '@malt/utils';
import {eventBus} from '~/lib/events';

let onAfterEnter: () => void;

const focusInput: Directive = {
    mounted(el) {
        const input = el.querySelector('input');

        const {isDisplayMobile} = useDisplayMobile('Xs');
        if (isDisplayMobile.value) {
            return;
        }

        input?.focus();

        onAfterEnter = () => {
            input?.focus();
        };
        // With client side navigation, We need to wait for the page transition to be finished
        eventBus.on('transition:after:enter', onAfterEnter);
    },
    beforeUnmount() {
        if (onAfterEnter) {
            eventBus.off('transition:after:enter', onAfterEnter);
        }
    },
};

export {focusInput};
